type UserWithEstateUnit = {
  estateUnitId?: string | null;
  estate_unit_id?: string | null;
  estateUnit?: { id?: string; name?: string };
  estate_unit?: { id?: string; name?: string };
};

export const resolveUserEstateUnitId = (user?: UserWithEstateUnit | null): string =>
  user?.estateUnitId ||
  user?.estate_unit_id ||
  user?.estateUnit?.id ||
  user?.estate_unit?.id ||
  '';

export const resolveUserEstateUnitName = (user?: UserWithEstateUnit | null): string =>
  user?.estateUnit?.name || user?.estate_unit?.name || '';
